export default function Footer() {
  const year = new Date().getFullYear();
  const nav = [
    { href: "#today", label: "今日最新" },
    { href: "#breaking", label: "刚刚爆" },
    { href: "#topics", label: "话题热榜" },
    { href: "#feature", label: "深度专题" },
    { href: "#about", label: "关于我们" },
    { href: "#faq", label: "常见问题" },
  ];
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="container-x grid grid-cols-1 gap-8 py-10 md:grid-cols-12 md:py-12">
        <div className="md:col-span-5">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-black text-background-50">每日瓜料</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-7 text-background-100/80">
            每天三档更新，突发实时跟进。把今天谁塌房、谁翻车、谁又有新瓜，用时间线讲得明明白白，不刷热搜也不错过重点。
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <a
              href="mailto:contact@meirigualiao.com"
              className="flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-2 text-sm text-background-100 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-mail-line" /> contact@meirigualiao.com
            </a>
            <a
              href="#top"
              className="flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-2 text-sm text-background-100 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-time-line" /> 每天 8:00 · 12:00 · 22:00 三档更新
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-sm font-bold uppercase tracking-wider text-background-50">栏目导航</h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {nav.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  className="inline-flex items-center gap-1.5 text-sm text-background-100/80 transition-colors hover:text-accent-300"
                >
                  <i className="ri-arrow-right-s-line text-accent-300/70" />
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="text-sm font-bold uppercase tracking-wider text-background-50">内容原则</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-100/80">
            <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-300" /> 先求证再发布，存疑标注求证中</li>
            <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-300" /> 时间线复盘，拒绝断章取义</li>
            <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-300" /> 理性吃瓜，不做情绪放大器</li>
            <li className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-300" /> 开放投稿，核实后择优采纳</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-100/70 sm:flex-row">
          <p>© {year} 每日瓜料 · 一个把娱乐热点讲清楚的中文资讯站</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-flashlight-fill text-accent-300" />
            今日瓜 · 今日爆 · 新料速递，一次看够
          </p>
        </div>
      </div>
    </footer>
  );
}